import React from 'react'
import About from '../component/About';
import Management from '../component/Management';

function AboutPage() {
  return (
    <div>
      <About />
      <Management />
    </div>
  )
}

export default AboutPage